import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import { ServiceGroup, URL_CATEGORIES } from '@/types/serviceGroup';
import { UserSession } from '@/types/userSession';
import { SERVICE_GROUP_ID } from '@/constants';

export const useExtractLinksFromService = (service: ServiceGroup) => {
  const userSession = useAppSelector(authStore.selectors.userSessionSelector);
  const isManager = useAppSelector(authStore.selectors.isManagerSelector);
  return extractLinksFromService(service, userSession, isManager);
};

const AUTH_URL_REGEX = /https?:\/\/(stg\d?\.)?auth\.globis\.co\.jp/;
const EMBA_URL_REGEX =
  /https:\/\/(stg-)?learning\.digitalglobis\.jp\/eLM\/admin\/dglp_check\.cfm/;

// FIXME: API側に処理持っててほしい
const extractLinksFromService = (
  service: ServiceGroup,
  session: UserSession,
  isManager: boolean,
) => {
  const attachedLinks = service.urls
    .filter((link) => {
      if (isManager) {
        return true;
      }
      return [
        URL_CATEGORIES.LANDINGPAGE,
        URL_CATEGORIES.ADMIN,
        URL_CATEGORIES.OTHERSSO,
      ].includes(link.category);
    })
    .map((link) => {
      const { url, category } = link;
      const { gloplaId, token } = session;
      const delimiter = url.indexOf('?') === -1 ? '?' : '&';
      const isTargetService = [
        SERVICE_GROUP_ID.hodai,
        SERVICE_GROUP_ID.gu,
        SERVICE_GROUP_ID.hodaiplus,
        SERVICE_GROUP_ID.newhodaiplus,
      ].includes(service.id);
      const isAdminCategory = category === URL_CATEGORIES.ADMIN;
      const isEmbaUrl = EMBA_URL_REGEX.test(url);
      const isGloplaIdIncluded = link.url.includes('glopla_id');

      if (
        !url.startsWith('http') &&
        category === URL_CATEGORIES.SUBSCRIPTIONLIST
      ) {
        link.url = `${url}${delimiter}service_group_id=${service.id}`;
      }

      /**
       * OIDC移行済みのサービスが対象
       * サービス側にSSOログインする際、組織選択をスキップするために、glopla_idをurlに付与する
       * 以下全ての条件が合致する場合のみ、glopla_idを付与する
       * 1. ServiceGroupがGLOBIS 学び放題、Unlimited、GLOBIS 学び放題プラス（旧）、GLOBIS 学び放題プラス（新）
       * 2. categoryがadmin(受講管理)
       * 3. eMBAのurl(https://learning.digitalglobis.jp/eLM/admin/dglp_check.cfm)以外
       * 4. urlにglopla_idが含まれていない場合
       * => 基盤側に対し、サービスグループAPIの情報を取得する際、2回処理が走るため、glopla_idが既に付与済みの場合は、付与しない
       */
      if (
        isTargetService &&
        isAdminCategory &&
        !isEmbaUrl &&
        !isGloplaIdIncluded
      ) {
        link.url = `${url}${delimiter}glopla_id=${gloplaId}`;
      }

      if (AUTH_URL_REGEX.test(url)) {
        link.url = `${url}${delimiter}at=${gloplaId}:${token}`;
      }
      return link;
    });

  return {
    admin: attachedLinks.filter(
      (link) => link.category === URL_CATEGORIES.ADMIN,
    ),
    subscribe:
      attachedLinks.find(
        (link) => link.category === URL_CATEGORIES.SUBSCRIBE,
      ) || null,
    subscriptionList:
      attachedLinks.find(
        (link) => link.category === URL_CATEGORIES.SUBSCRIPTIONLIST,
      ) || null,
    landingPage:
      attachedLinks.find(
        (link) => link.category === URL_CATEGORIES.LANDINGPAGE,
      ) || null,
    otherSso:
      attachedLinks.find((link) => link.category === URL_CATEGORIES.OTHERSSO) ||
      null,
  };
};
